var map = {
	"./ca.json": [
		"./src/assets/i18n/ca.json",
		0
	],
	"./en.json": [
		"./src/assets/i18n/en.json",
		1
	],
	"./es.json": [
		"./src/assets/i18n/es.json",
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return Object.assign({/* fake namespace object */}, typeof module === "object" && module, { "default": module });
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;